<div
  *ngIf="categories.length && sessionService?.tenant?.tenantCategories"
  class="category-select"
  [ngClass]="wrapperClass"
>
  <form
    [formGroup]="categoryForm"
    class="d-md-flex align-items-center category-select__form"
  >
    <div
      *ngFor="let category of categories"
      class="mb-2 mb-md-0 category-select__form--item"
    >
      <label
        *ngIf="showLabel"
        [for]="category.name"
        class="font-weight-bold filter-label"
        >{{ category.name }}</label
      >
      <ng-select
        [id]="category.name"
        [formControlName]="category.name"
        [items]="category.categoryTags"
        bindLabel="content"
        bindValue="id"
        [placeholder]="showLabel ? 'Select' : category.name"
        [closeOnSelect]="isSmallScreen"
        [multiple]="true"
        (clear)="onClear()"
      >
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          <input
            class="option-checkbox"
            id="item-{{ index }}"
            type="checkbox"
            [checked]="item$.selected"
          />
          {{ item.content }}
        </ng-template>

        <ng-template ng-label-tmp let-item="item">
          {{ item.content
          }}{{ shouldShowComma(item, category.name) ? ', ' : '' }}
        </ng-template>
      </ng-select>
    </div>

    <div
      *ngIf="isSmallScreen ? showFilterBtn : (showFilterBtn && hasFilters())"
      class="d-flex align-items-center justify-content-end category-select__buttons"
    >
      <button
        *ngIf="false"
        type="submit"
        class="btn btn-outline-secondary mx-1 font-weight-bold text-uppercase d-flex align-items-center"
        (click)="onSubmit()"
      >
        <div class="category-select__buttons--icons mr-2">
          <i class="fas fa-filter"></i>
          <i *ngIf="filterCount" class="fas fa-circle"></i>
        </div>
        {{ 'Filters' | translate }}
        <span *ngIf="filterCount">({{ filterCount }})</span>
      </button>

      <button
        *ngIf="hasFilters()"
        (click)="resetAll()"
        class="btn btn-link form-section__btn clear-all-btn ml-2 font-size-base"
        translate
      >
        UI.Categories.ResetAll
      </button>
    </div>
  </form>
</div>
